import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "form", "reason", "resourceName", "valueSelect"]

  open(event) {
    const button = event.currentTarget
    if (!button) return

    // Dismiss any Bootstrap tooltip on the button before proceeding
    const tip = bootstrap.Tooltip.getInstance(button)
    if (tip) tip.hide()

    const nudgeUrl  = button.dataset.nudgeUrl
    const adjustUrl = button.dataset.adjustUrl
    const resourceName = button.dataset.nudgeResourceName
    const currentValue = parseInt(button.dataset.currentValue)
    const maxValue = parseInt(button.dataset.maxValue) || 5
    const labels = JSON.parse(button.dataset.valueLabels || "{}")

    // Shift+click: bypass modal and nudge by 1 directly
    if (event.shiftKey) {
      this.directNudge(nudgeUrl)
      return
    }

    // Populate value select filtered to valid direction, pre-selecting the adjacent value
    const delta = parseInt(button.dataset.nudgeDelta)
    const select = this.valueSelectTarget
    select.innerHTML = ""
    for (let v = 1; v <= maxValue; v++) {
      if (delta > 0 && v <= currentValue) continue
      if (delta < 0 && v >= currentValue) continue
      const option = document.createElement("option")
      option.value = v
      const label = labels[v] || `Value ${v}`
      option.textContent = `${v} - ${label}`
      select.appendChild(option)
    }
    // Pre-select the adjacent step
    const adjacentValue = currentValue + delta
    const adjacentOption = select.querySelector(`option[value="${adjacentValue}"]`)
    if (adjacentOption) adjacentOption.selected = true

    this.resourceNameTarget.textContent = resourceName
    this.formTarget.action = adjustUrl
    this.reasonTarget.value = ""

    const modal = new bootstrap.Modal(this.modalTarget)
    modal.show()

    this.modalTarget.addEventListener("shown.bs.modal", () => {
      this.valueSelectTarget.focus()
    }, { once: true })
  }

  async directNudge(url) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "X-CSRF-Token": csrfToken, "Accept": "text/html" },
        redirect: "follow"
      })
      if (response.ok || response.redirected) window.location.reload()
    } catch (err) {
      console.error("Nudge failed:", err)
    }
  }

  submit(event) {
    event.preventDefault()
    this.formTarget.requestSubmit()
  }
}
